import { DateRangeInput2 } from '@blueprintjs/datetime2';
import * as React from 'react';
import { Body } from 'vet-bones/design-system/components';
import { formatDate, parseDatePickerInput } from 'vet-bones/utils';

import { SDU_DASHBOARD_DATE_RANGE } from 'src/ui/constants/testIds';
import * as copy from 'src/ui/templates/copy';

const MIN_DATE = new Date('1900-01-01');

interface SduDateRangePickerProps {
  onChange: (range: [Date | null, Date | null]) => void;
  value: [Date | null, Date | null];
}

export const SduDateRangePicker: React.VFC<SduDateRangePickerProps> = ({
  onChange,
  value,
}) => (
  <div className="organization-dashboard-card">
    <div className="sd-sdu-dashboard-date-range">
      <Body size="md" testId={SDU_DASHBOARD_DATE_RANGE}>
        {copy.components.sduDashboard.dateRangeLabel}
      </Body>
      <DateRangeInput2
        formatDate={formatDate}
        maxDate={new Date()}
        minDate={MIN_DATE}
        onChange={onChange}
        parseDate={parseDatePickerInput}
        placeholder={copy.components.sduDashboard.dateRangePlaceholder}
        shortcuts={false}
        singleMonthOnly
        value={value}
      />
    </div>
  </div>
);
